// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountRequirementsErrorArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiAccountRequirementsErrorCodeEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountRequirementsErrorArkFragment on OpenapiAccountRequirementsError {
    code
    reason
    requirement
    suggestion {
      message
    }
    details {
      missing_directors {
        first_name
        full_name
        id_number
        id_number_last_4
        last_name
        person_token
      }
      missing_owners {
        first_name
        full_name
        id_number
        id_number_last_4
        last_name
        person_token
      }
      extraneous_directors {
        first_name
        full_name
        id_number
        id_number_last_4
        last_name
        person_token
      }
    }
  }
`;

export const stripeAccountRequirementsErrorArkFragment: StripeAccountRequirementsErrorArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountRequirementsErrorArkFragmentData = {
  readonly __typename: 'OpenapiAccountRequirementsError';
  readonly code: OpenapiAccountRequirementsErrorCodeEnum;
  readonly reason: string;
  readonly requirement: string;
  readonly suggestion: {
    readonly __typename: 'OpenapiAccountErrorSuggestion';
    readonly message: string;
  } | null;
  readonly details: {
    readonly __typename: 'OpenapiAccountRequirementsErrorDetails';
    readonly missing_directors: ReadonlyArray<{
      readonly __typename: 'OpenapiAccountMissingPerson';
      readonly first_name: string | null;
      readonly full_name: string | null;
      readonly id_number: string | null;
      readonly id_number_last_4: string | null;
      readonly last_name: string | null;
      readonly person_token: string | null;
    }> | null;
    readonly missing_owners: ReadonlyArray<{
      readonly __typename: 'OpenapiAccountMissingPerson';
      readonly first_name: string | null;
      readonly full_name: string | null;
      readonly id_number: string | null;
      readonly id_number_last_4: string | null;
      readonly last_name: string | null;
      readonly person_token: string | null;
    }> | null;
    readonly extraneous_directors: ReadonlyArray<{
      readonly __typename: 'OpenapiAccountMissingPerson';
      readonly first_name: string | null;
      readonly full_name: string | null;
      readonly id_number: string | null;
      readonly id_number_last_4: string | null;
      readonly last_name: string | null;
      readonly person_token: string | null;
    }> | null;
  } | null;
};

export type StripeAccountRequirementsErrorArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountRequirementsErrorArkFragmentPermissions = {} as const;

doc.permissions = stripeAccountRequirementsErrorArkFragmentPermissions;

export type StripeAccountRequirementsErrorArkFragmentPermissions =
  V1PermissionToken<
    typeof stripeAccountRequirementsErrorArkFragmentPermissions
  >;

export type StripeAccountRequirementsErrorArkFragmentDocument = GraphQlDocument<
  StripeAccountRequirementsErrorArkFragmentData,
  StripeAccountRequirementsErrorArkFragmentVariables,
  StripeAccountRequirementsErrorArkFragmentPermissions
>;
